/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'usPersonCheckbox',
    'usPersonDetails',
    'usPersonNumber',
    'taxResidenceInOcdeCheckbox',
    'taxResidenceInOcdeDetails',
    'taxResidenceInOcdeCountry',
    'taxResidenceInOcdeTaxNumber',
    'addCountryButton',
    'countryTemplate',
  ];

  static values = { formClass: String };

  connect() {
    this.newCountryTemplate = this.countryTemplateTarget.outerHTML;

    this.setupCountryFields();

    $(this.usPersonNumberTarget).mask('000-00-0000', { reverse: false });

    $(`.${this.formClassValue}`).on('submit', (e) => {
      if (!this.validateUsPersonNumber() || !this.validateTaxResidenceInOcdeTaxNumbers()) {
        e.preventDefault();
      }
    });
  }

  setupCountryFields() {
    const $taxResidenceInOcdeCountry = $(this.taxResidenceInOcdeCountryTargets);

    $taxResidenceInOcdeCountry.select2({
      language: {
        noResults() {
          return 'País não listado na OCDE';
        },
      },
    });
  }

  addNewCountryField() {
    const $addCountryButton = $(this.addCountryButtonTarget);

    $addCountryButton.before(this.newCountryTemplate);

    this.setupCountryFields();

    $.$EventBus.emit('form:reattachValidation');
  }

  removeCountryField(e) {
    const $form = $(`.${this.formClassValue}`);
    const $taxResidenceInOcdeCountries = $(this.taxResidenceInOcdeCountryTargets);
    const $button = $(e.target);

    if ($taxResidenceInOcdeCountries.length === 1) {
      return;
    }

    $button.closest('.fiscal-info__row').remove();
    $form.trigger('change');
  }

  toggleUsPersonDetails() {
    $(this.usPersonDetailsTarget).toggle();
  }

  toggleTaxResidenceInOcdeDetails() {
    $(this.taxResidenceInOcdeDetailsTarget).toggle();
  }

  validateUsPersonNumber() {
    // Regex from https://uibakery.io/regex-library/ssn
    const ssnRegex = /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
    const $ssnInput = $(this.usPersonNumberTarget);
    const ssn = $ssnInput.val();

    const $usPersonCheckbox = $(this.usPersonCheckboxTarget);

    if (!$usPersonCheckbox.is(':checked')) {
      return true;
    }

    if (ssn.length < 11) {
      $ssnInput.addClass('is-invalid');
      $ssnInput.siblings('.h-form__feedback--invalid').text('Número de caractéres insuficiente');

      return false;
    }

    if (!ssnRegex.test(ssn)) {
      $ssnInput.addClass('is-invalid');
      $ssnInput.siblings('.h-form__feedback--invalid').text('SSN inválido');

      return false;
    }

    return true;
  }

  validateTaxResidenceInOcdeTaxNumbers() {
    const $taxResidenceInOcdeCheckbox = $(this.taxResidenceInOcdeCheckboxTarget);
    const $taxResidenceInOcdeTaxNumbers = $(this.taxResidenceInOcdeTaxNumberTargets);

    let isValid = true;

    if (!$taxResidenceInOcdeCheckbox.is(':checked')) {
      return true;
    }

    for (const number of $taxResidenceInOcdeTaxNumbers) {
      const $numberInput = $(number);

      if ($numberInput.val().length < 5) {
        $numberInput.addClass('is-invalid');
        $numberInput.siblings('.h-form__feedback--invalid').text('Número de caracteres insuficiente');

        isValid = false;
      }

      if ($numberInput.val().length > 18) {
        $numberInput.addClass('is-invalid');
        $numberInput.siblings('.h-form__feedback--invalid').text('Número de caracteres acima do esperado');

        isValid = false;
      }
    }

    return isValid;
  }
}
